import { onMounted, onUnmounted, useSlots } from 'vue';

export function useReference(onReference, events = {}, fallbackReference = null) {
    const slots = useSlots();
    let reference = null;

    function getReference() {
        const defaultSlot = slots.default?.();

        const element = defaultSlot?.[0]?.elm;

        return element instanceof HTMLElement ? element : fallbackReference?.value;
    }

    onMounted(() => {
        reference = getReference();

        if (!reference) return;

        Object.keys(events).forEach(event => reference.addEventListener(event, events[event], false));

        onReference?.(reference);
    });

    onUnmounted(() => {
        if (!reference) return;

        Object.keys(events).forEach(event => reference.removeEventListener(event, events[event], false));

        reference = null;
    });
}
